var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2692 6.175C14.4264 5.9455 14.443 5.6475 14.3131 5.40156C14.1848 5.15313 13.9285 5 13.6504 5H8.75646L10.3453 1.02813C10.4381 0.797656 10.4097 0.535 10.2701 0.32875C10.1304 0.1225 9.87212 0 9.65024 0H4.15005C3.7741 0 3.45659 0.278313 3.4069 0.65125L2.40686 8.15125C2.37755 8.36563 2.44299 8.58125 2.58555 8.74375C2.72812 8.90625 2.93407 9 3.15001 9H7.72205L6.41638 15.0656C6.34119 15.4163 6.52479 15.7706 6.85389 15.9122C6.95015 15.9812 7.05015 16 7.15015 16C7.39138 16 7.62579 15.8828 7.76924 15.6737L14.2692 6.175ZM8.34082 8H3.43596L4.36943 1H9.2821L7.55329 5.31563C7.42204 5.64375 7.6658 6 8.01893 6H13.1754L7.65955 14.0344L8.82927 8.57813C8.89709 8.29375 8.65958 8 8.34082 8Z",
    fill: "#149CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.a0820ff776803dad2c2da87d611285a1.svg";
export { ForwardRef as ReactComponent };